import { gql } from "@apollo/client";

export const CLEAR_CONTEXT_FOR_CHAT = gql`
  mutation ClearContextForChat($chatId: ID!) {
    clearContextSelection(chatId: $chatId) {
      id
      isLocked
      createdAt
      updatedAt
    }
  }
`;
